// eslint-disable-next-line no-restricted-imports
import Checkbox from '@mui/material/Checkbox';

import { Typography } from '../Typography';
import { styled } from '../styled';

const MEDIUM_SIZE = 24;
const SMALL_SIZE = 16;

export const StyledCheckbox = styled(Checkbox)(({ theme, size, readOnly }) => {
  const width = size === 'medium' ? MEDIUM_SIZE : SMALL_SIZE;
  return {
    padding: 0,
    cursor: readOnly ? 'default' : 'pointer',
    '& .checkbox-icon': {
      padding: width / 4 / 2,
      height: width,
      width,
      '& div': {
        height: '100%',
        width: '100%',
        borderRadius: 4,
        border: `2px solid ${theme.palette.checkboxBorder}`,
      },
    },

    ...(!readOnly && {
      '&:hover .checkbox-icon div': {
        backgroundColor: theme.palette.checkboxHover,
      },
    }),

    '&.Mui-disabled .checkbox-icon div': {
      backgroundColor: theme.palette.checkboxDisabledBg,
    },

    '& .checkbox-checkedIcon': {
      height: width,
      width,
      '& rect': {
        fill: theme.palette.checkboxSelectedBg,
      },

      '& path': {
        stroke: theme.palette.checkboxSelectedIconBg,
      },
    },
    ...(!readOnly && {
      '&:hover .checkbox-checkedIcon path': {
        stroke: theme.palette.checkboxSelectedHoverIconBg,
      },
    }),

    '&.Mui-disabled .checkbox-checkedIcon': {
      '& path': {
        stroke: theme.palette.checkboxSelectedDisabledIconBg,
      },
      '& rect': {
        fill: theme.palette.checkboxDisabledBg,
      },
    },
  };
});

export const LabelStyled = styled(Typography)(() => ({
  lineHeight: 1,
}));
